import { DiscountTooltip } from '@/components/DiscountTooltip/DiscountTooltip'
import { useDiscountTooltipProps } from '@/components/DiscountTooltip/useDiscountTooltipProps'
import { BUNDLE_DISCOUNT_ELIGIBLE_PRODUCT_IDS } from '@/features/bundleDiscount/bundleDiscount.constants'
import { BundleDiscountOfferTooltip } from '@/features/bundleDiscount/components/BundleDiscountOfferTooltip'
import { type ProductOfferFragment } from '@/services/graphql/generated'
import { useShopSessionValueOrThrow } from '@/services/shopSession/ShopSessionContext'
import { usePriceIntent } from '../usePriceIntent'

export function DiscountHighlight({ selectedOffer }: { selectedOffer: ProductOfferFragment }) {
  const shopSession = useShopSessionValueOrThrow()
  const { priceIntent } = usePriceIntent()
  const discountTooltipProps = useDiscountTooltipProps(selectedOffer, shopSession.cart.redeemedCampaign ?? undefined)

  if (!priceIntent) {
    return null
  }

  if (discountTooltipProps != null) {
    return <DiscountTooltip {...discountTooltipProps} orientation="bottom" />
  } else if (
    shopSession.experiments?.bundleDiscount &&
    BUNDLE_DISCOUNT_ELIGIBLE_PRODUCT_IDS.has(priceIntent.product.id)
  ) {
    return <BundleDiscountOfferTooltip offer={selectedOffer} orientation="bottom" />
  }

  return null
}
